<template>
  <a-drawer
    :title="title"
    width="60%"
    :visible="visible"
    :body-style="{ paddingBottom: '80px' }"
    @close="onClose"
  >
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <!-- 基本信息 -->
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="存储记录ID">{{ detailData.id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="存储类型">
            <a-tag :color="getTypeColor(detailData.type)">
              {{ getTypeText(detailData.type) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="存储费类型">
            <a-tag :color="getRenewTypeColor(detailData.renewType)">
              {{ getRenewTypeText(detailData.renewType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="状态">
            <a-tag :color="getStatusColor(detailData.status)">
              {{ getStatusText(detailData.status) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="生效状态">
            <a-tag :color="getEffectiveStatusColor(detailData.effectiveStatus)">
              {{ getEffectiveStatusText(detailData.effectiveStatus) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="到期状态">
            <a-tag :color="getExpireStatusColor(detailData.expireStatus)">
              {{ getExpireStatusText(detailData.expireStatus) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="关联套餐ID">{{ detailData.packageId || '-' }}</a-descriptions-item>
          <a-descriptions-item label="最后统计日期">{{ detailData.lastStatDate || '-' }}</a-descriptions-item>
        </a-descriptions>

        <!-- 容量信息 -->
        <a-descriptions title="容量信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="总容量">
            <span class="capacity-value">{{ $formatCapacity(detailData.totalCapacity) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="已使用容量">
            <span class="capacity-value">{{ $formatCapacity(detailData.usedCapacity) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="剩余容量">
            <span class="capacity-value">{{ $formatCapacity(detailData.remainingCapacity) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="使用率">
            <div class="usage-rate">
              <div class="usage-progress">
                <div
                  class="progress-bar"
                  :style="{ width: getUsageRate() + '%', backgroundColor: getUsageRateColor() }"
                ></div>
              </div>
              <span class="rate-text">{{ getUsageRate() }}%</span>
            </div>
          </a-descriptions-item>
        </a-descriptions>

        <!-- 时间信息 -->
        <!-- <a-descriptions title="时间信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) }}</a-descriptions-item>
          <a-descriptions-item label="激活时间">{{ formatTime(detailData.activationTime) }}</a-descriptions-item>
          <a-descriptions-item label="生效时间">{{ formatTime(detailData.effectiveTime) }}</a-descriptions-item>
          <a-descriptions-item label="到期时间">{{ formatTime(detailData.expireTime) }}</a-descriptions-item>
          <a-descriptions-item label="生效提醒时间">{{ formatTime(detailData.effectiveReminderTime) }}</a-descriptions-item>
          <a-descriptions-item label="失效提醒时间">{{ formatTime(detailData.expireReminderTime) }}</a-descriptions-item>
        </a-descriptions> -->

        <!-- 其他信息 -->
        <a-descriptions title="其他信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="备注">{{ detailData.remark || '无备注' }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="onClose">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getDetail } from '@/api/VR/tenantStorage/index'
import moment from 'moment'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      title: '存储详情',
      detailData: {},
    }
  },
  methods: {
    show(record) {
      console.log(record, 222)
      this.visible = true
      this.title = `存储详情`
      this.loadDetail(record.id)
    },

    hide() {
      this.visible = false
      this.detailData = {}
    },

    onClose() {
      this.hide()
    },

    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getDetail({
          id,
        })
        if (response.success) {
          this.detailData = response.data || {}
        } else {
          this.$message.error('加载详情失败')
        }
      } catch (error) {
        console.error('加载存储详情失败:', error)
        this.$message.error('加载存储详情失败')
      } finally {
        this.loading = false
      }
    },

    // 格式化容量显示 (MB转GB)
     formatCapacity(capacity) {
      if (!capacity && capacity !== 0) return '0G'

      const totalMB = capacity

      if (totalMB < 1024) {
        return `${totalMB}M`
      }

      const gb = Math.floor(totalMB / 1024)
      const mb = totalMB % 1024

      if (mb === 0) {
        return `${gb}G`
      }

      return `${gb}G.${mb}M`
    },

    // 格式化时间显示
    formatTime(time) {
      if (!time) return '-'
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },

    // 计算使用率
    getUsageRate() {
      if (!this.detailData.totalCapacity || this.detailData.totalCapacity === 0) return 0
      const rate = ((this.detailData.usedCapacity || 0) / this.detailData.totalCapacity * 100)
      return Math.min(100, Math.max(0, rate.toFixed(1)))
    },

    // 获取使用率颜色
    getUsageRateColor() {
      const rate = this.getUsageRate()
      if (rate >= 90) return '#ff4d4f'
      if (rate >= 70) return '#faad14'
      return '#52c41a'
    },

    // 存储类型相关方法
    getTypeText(type) {
      const typeMap = { 0: '自有存储池', 1: '企业配额' }
      return typeMap[type] || '-'
    },

    getTypeColor(type) {
      const colorMap = { 0: 'blue', 1: 'green' }
      return colorMap[type] || 'default'
    },

    // 存储费类型相关方法
    getRenewTypeText(renewType) {
      const renewTypeMap = { 0: '标准', 1: '安心存储', 2: '灵活存储' }
      return renewTypeMap[renewType] || '-'
    },

    getRenewTypeColor(renewType) {
      const colorMap = { 0: 'blue', 1: 'green', 2: 'orange' }
      return colorMap[renewType] || 'default'
    },

    // 状态相关方法
    getStatusText(status) {
      const statusMap = { 0: '禁用', 1: '有效' }
      return statusMap[status] || '-'
    },

    getStatusColor(status) {
      const colorMap = { 0: 'red', 1: 'green' }
      return colorMap[status] || 'default'
    },

    // 生效状态相关方法
    getEffectiveStatusText(effectiveStatus) {
      const statusMap = { 0: '未生效', 1: '已生效', 2: '已过期' }
      return statusMap[effectiveStatus] || '-'
    },

    getEffectiveStatusColor(effectiveStatus) {
      const colorMap = { 0: 'orange', 1: 'green', 2: 'red' }
      return colorMap[effectiveStatus] || 'default'
    },

    // 到期状态相关方法
    getExpireStatusText(expireStatus) {
      const statusMap = { 0: '已过期', 1: '未到期' }
      return statusMap[expireStatus] || '-'
    },

    getExpireStatusColor(expireStatus) {
      const colorMap = { 0: 'red', 1: 'green' }
      return colorMap[expireStatus] || 'default'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

.capacity-value {
  font-weight: 600;
  color: #1890ff;
}

.usage-rate {
  display: flex;
  align-items: center;
  gap: 8px;
}

.usage-progress {
  flex: 1;
  height: 6px;
  background-color: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.rate-text {
  font-size: 12px;
  color: #666;
  min-width: 40px;
}
</style>
